import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { setupGlobalErrorHandler } from "./lib/errorLogger";
import { startVersionCheck } from "./lib/versionCheck";

// Set up global error capturing
setupGlobalErrorHandler();

// Detect new deploys and force a hard refresh so users always get the latest bundle.
startVersionCheck();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
